
<template>
    <!--ToolBox -->
    <div class="toolboxMobile box p-0 mx-0" >       
        <div :id="toolType" class="bg-white pt-1 pb-0 pb-lg-1 d-flex justify-content-around d-lg-bloc px-1 px-md-0 flex-wrap border-gris-pro rounded-bottom-10 border-5">
            <div class="tool px-2 mx-0 col-3" @click="select('circle')" :class="{ active : tool === 'circle'}">
                <div class="rounded-10 p-2 bg-gris-pro rounded-10">
                    <svg viewBox="-.5 -.5 17 17" height="45" width="45" focusable="false" role="img" aria-label="circle fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-circle-fill d-block mx-auto p-1 b-icon bi"><circle cx="8" cy="8" r="8"></circle></svg>
                    <span class="small font-weiht-bold"><t toolBoxMobile.circle /></span>
                </div>
            </div>
            <div @click="select('rectangle')" :class="{ active : tool === 'rectangle'}" class="tool px-2 mx-0 col-3">
                <div class="rounded-10 py-2 bg-gris-pro rounded-10">
                    <svg viewBox="-.5 -.5 17 17" width="45" height="45" focusable="false" role="img" aria-label="square fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-square-fill d-block mx-auto p-1 b-icon bi">
                        <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z"></path>
                    </svg>
                    <span class="small font-weiht-bold"><t toolBoxMobile.rectangle /></span>
                </div>
            </div>
            <div @click="select('triangle')" :class="{ active : tool === 'triangle'}" class="tool px-2 mx-0 col-3">
                <div class="rounded-10 p-2 bg-gris-pro rounded-10">
                    <svg viewBox="-.5 -.5 17 17" width="45" height="45" focusable="false" role="img" aria-label="triangle fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-triangle-fill d-block mx-auto p-1 b-icon bi">
                        <path fill-rule="evenodd" d="M7.022 1.566a1.13 1.13 0 0 1 1.96 0l6.857 11.667c.457.778-.092 1.767-.98 1.767H1.144c-.889 0-1.437-.99-.98-1.767L7.022 1.566z"></path>
                    </svg>
                    <span class="small font-wight-bold"><t toolBoxMobile.triangle /></span>
                </div>
            </div>
            <div @click="select('text')" :class="{ active : tool === 'text'}" class="tool px-2 mx-0 col-3">
                <div class="rounded-10 p-2 bg-gris-pro rounded-10">
                    <b-icon height="45" width="45" class="d-block mx-auto" icon="fonts" />
                    <span class="small font-weght-bold"><t toolBoxMobile.text /></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { BIcon, BIconCursorFill, BIconTrash, BIconCircleFill, BIconSquareFill, BIconInfoSquareFill, BIconFonts, BIconBoxArrowInRight, BIconBoxArrowRight, BIconStarFill, BIconTriangleFill, BIconPlus, BIconScissors }
    from 'bootstrap-vue';
    import { mapGetters } from 'vuex'

    export default {
        components: {
            BIcon,
            // eslint-disable-next-line vue/no-unused-components
            BIconCursorFill, BIconTrash, BIconSquareFill, BIconCircleFill, BIconInfoSquareFill, BIconFonts, BIconBoxArrowInRight, BIconBoxArrowRight, BIconStarFill, BIconTriangleFill, BIconPlus, BIconScissors
        },
        data() {
            return {
                landingpage: window.obelix.landingpage
            }
        },

        computed: {
            ...mapGetters([
                'tool',
                'isOpenIconsModal',
                'selectedShape',
                'materialName',
                'toolType',
                'shapes'
            ])
        },

        methods: {
            select(tool) {
                if (tool != this.tool) {
                    this.$store.dispatch('setWhiteboardTool', tool);
                } else {
                    this.$store.dispatch('setWhiteboardTool', 'selecter');
                }
                this.$store.dispatch('setDropped', null);
            },
            async onJsHomeReturn(){
                if(window.obelix.onJsHomeReturn) window.obelix.onJsHomeReturn();
            },
            selectToolType(type) {
                this.$store.dispatch('setToolType', type);
            }
        },

        watch: {
            selectedShape: async function() {
                if (this.selectedShape) {
                    if (this.selectedShape.isCut) {
                        document.querySelector('#mobile-tools button').setAttribute('disabled', 'disabled');
                    } else {
                        document.querySelector('#mobile-tools button').removeAttribute('disabled');
                        this.$store.dispatch('setToolType', 'cut');
                    }
                } else {
                    document.querySelector('#mobile-tools button').removeAttribute('disabled');
                    this.$store.dispatch('setToolType', 'add');
                }
            }
        }
    }
</script>

<style lang="scss">
    @import './../../assets/scss/_variables.scss';
    
    .toolboxMobile {
        width: 59px;
        padding: 0.5rem;
        grid-template-columns: auto auto;
        width: 100%;
        gap: 0.5rem;
        background-color: $white;

        @media (max-width: 768px) {
            border-radius: 0;
        }

        .tool {
            color: $dark;
            margin: 7px;
            border-radius: 10px;
            text-align: center;

            &:not(.active):hover svg,
            &.active svg{
                @media (min-width: 768px) {
                    background: $dark;
                    fill: $grispro;
                }
            }

            svg {
                transition: all .3s ease-in-out;
                overflow: visible!important;
            }
        }

        #add {
            svg {
                border-radius: 10px;
                fill: #dbd8d8;
                stroke: #6c757d;
                stroke-width: .5;
            }

            .tool.active {
                div {
                    background: $grispro;
                }

                svg {
                    fill: $jaune;
                }
            } 
        }
        
        #cut {
            svg {
                fill: white;
                stroke: #6c757d;
                stroke-width: .5;
            }
            .tool.active {
                div {
                    background: $grispro;
                }

                svg {
                    stroke: $jaune;
                }
            } 
        }
    }

    .title-rounded {
        border-radius: 10px 10px 10px 0;
    }

    .svg-inline--fa {
        font-size: 20px;
        cursor: pointer;
        height: 20px;
        width: 20px;
    }

    .toolboxMobile .custom-control {
        top: -4px;
    }

    .custom-control-input:checked~.custom-control-label {
        outline: none;

        &::before {
            border-color: $jaune!important;
            background-color: $jaune!important;
        }
    }
    .custom-control-input:focus~.custom-control-label::before {
        box-shadow: none!important;
    }
    .custom-control-input:focus:not(:checked)~.custom-control-label::before {
        border-color: $jaune!important;
    }
</style>